<template>
  <div class="tw-max-w-[630px] tw-w-full mainWrapper">
    <!-- Dropdown button start -->
    <div
      :class="`${isOpen ? '' : 'tw-rounded-bl-[6px] tw-rounded-br-[6px]'} ${
        selectedAssessmentParentRef.includes(index) ? 'selected' : ''
      } tw-overflow-x-auto tw-w-full tw-rounded-tl-[6px] tw-rounded-tr-[6px] tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[5px] tw-self-stretch tw-border tw-px-[25px] tw-py-5 tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]`"
    >
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-gap-[15px] tw-items-center">
          <div>
            <ToggleIcon
              :ticked="selectedAssessmentParentRef.includes(index)"
              color="#387DFF"
              @click="
                () => {
                  isSelected = false;
                  selectedParentAssessment(index);
                  selectedAssessments = [];
                }
              "
            />
          </div>
          <div
            class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-[600] tw-leading-[130%]"
          >
            <span>{{ name }}</span>
            <span v-if="date" class="tw-font-[400]"> - </span>
            <span class="tw-font-[400]">{{ date }}</span>
          </div>
          <AssessmentChecklistStatusTag
            :checklist-status="checklistInforDetail.checklistStatus"
            :checklist-status-id="checklistInforDetail.checklistStatusId"
            :is-loading="false"
          />
        </div>
        <div class="tw-flex tw-items-center tw-gap-[15px]">
          <span
            class="tw-cursor-pointer arrow"
            @click="
              () => {
                isOpen = !isOpen;
                emit('onToggle', index);
              }
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              :style="isOpen ? '' : 'transform: rotate(180deg)'"
            >
              <path
                d="M11.8741 6.39285L6.38429 0.169354C6.33485 0.117097 6.27527 0.0754726 6.2092 0.0470253C6.14312 0.0185781 6.07194 0.00390599 6 0.00390599C5.92806 0.00390598 5.85688 0.0185781 5.7908 0.0470253C5.72473 0.0754725 5.66515 0.117097 5.61571 0.169354L0.125859 6.39285C0.081969 6.44228 0.0483386 6.49995 0.02692 6.56249C0.00550146 6.62503 -0.00327902 6.69121 0.00108975 6.75717C0.0065009 6.82367 0.0251891 6.8884 0.056049 6.94755C0.086909 7.0067 0.129313 7.05906 0.180757 7.10154L1.10405 7.87511C1.15449 7.91873 1.21315 7.95181 1.27658 7.97238C1.34002 7.99295 1.40693 8.00061 1.47337 7.99488C1.53949 7.9901 1.604 7.97219 1.66313 7.9422C1.72225 7.91221 1.77481 7.87074 1.81773 7.82021L5.91516 3.10393C5.94039 3.07894 5.97447 3.06492 6.00998 3.06492C6.04549 3.06492 6.07957 3.07894 6.10481 3.10393L10.1823 7.82021C10.2629 7.91657 10.377 7.97895 10.5017 7.99489C10.5678 8.00129 10.6345 7.99443 10.6979 7.97472C10.7613 7.95501 10.8202 7.92284 10.871 7.8801L11.8192 7.10154C11.8707 7.05906 11.9131 7.0067 11.9439 6.94755C11.9748 6.8884 11.9935 6.82367 11.9989 6.75717C12.0033 6.69121 11.9945 6.62503 11.9731 6.56249C11.9517 6.49995 11.918 6.44229 11.8741 6.39285Z"
                fill="#387DFF"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <!-- Dropdown button end -->
    <!-- Dropdown body start -->
    <div
      :class="`tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-5 tw-self-stretch tw-p-5 tw-rounded-bl-[6px] tw-rounded-br-[6px] assessmentHistoryWrapper ${
        isOpen ? '' : 'close'
      }`"
    >
      <div class="tw-w-full tw-flex tw-flex-col tw-gap-[20px]">
        <div
          class="tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-[600] tw-leading-[100%] tw-tracking-[1px] tw-uppercase"
        >
          {{
            getComponentUiText(
              "app-component-assessment-existing-assessment-dropdown-subtitle-assessment-history-1",
            )
          }}
        </div>
        <div class="assessmentHistory">
          <div
            v-for="(assessment, _index) in props.history as any"
            :key="_index"
            :class="`tw-overflow-x-auto tw-flex tw-items-center tw-gap-[15px] tw-self-stretch tw-px-[25px] tw-py-[18px] assessment ${
              selectedAssessments.includes(assessment.checklistId) &&
              assessmentSelectedId === assessment.checklistId
                ? 'selected'
                : ''
            } `"
          >
            <div class="tw-flex tw-gap-[15px] tw-items-center">
              <div>
                <ToggleIcon
                  :ticked="
                    selectedAssessments.includes(assessment.checklistId) &&
                    assessmentSelectedId === assessment.checklistId
                  "
                  color="#387DFF"
                  @click="
                    () => {
                      isSelected = false;
                      if (
                        selectedAssessments.includes(assessment.checklistId) &&
                        assessmentSelectedId === assessment.checklistId
                      ) {
                        selectedAssessments.splice(
                          selectedAssessments.indexOf(assessment.checklistId),
                          1,
                        );
                        selectedAssessments = [];
                      } else {
                        selectedAssessments = [];
                        selectedAssessments.push(assessment.checklistId);
                      }
                      selectedAssessment(_index);
                    }
                  "
                />
              </div>
              <div>
                <img
                  v-if="_index === 0"
                  class="dropdown-button-arrow-img"
                  src="@/assets/img/active-clock.svg"
                />
                <img
                  v-else
                  class="dropdown-button-arrow-img"
                  src="@/assets/img/unactive-clock.svg"
                />
              </div>
              <div class="tw-flex tw-gap-[10px] tw-items-center">
                <div
                  class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[normal]"
                >
                  <span>{{ assessment.name || assessment.checklistName }}</span>
                  <span
                    v-if="assessment.date || assessment.checklistDateCreated"
                    class="tw-text-[#878787] tw-font-[400] tw-leading-[normal]"
                  >
                    -
                  </span>
                  <span
                    v-if="assessment.date || assessment.checklistDateCreated"
                    class="tw-text-[#878787] tw-font-[400] tw-leading-[normal]"
                    >{{
                      assessment.date ||
                      convertUTCTimeToLocalTime(assessment.checklistDateCreated)
                    }}</span
                  >
                </div>
              </div>
              <AssessmentStatus :state="assessment?.checklistStatus" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dropdown button end -->
  </div>
</template>

<script setup lang="ts">
import { Ref, ref, watch } from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import AssessmentStatus from "./assessmentStatus.vue";
import { assessmentStatus } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import AssessmentChecklistStatusTag from "../assessment/assessmentChecklistStatusTag.vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  checklistInforDetail: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    required: false,
    default: "",
  },
  isLarge: {
    type: Boolean,
    required: false,
    default: false,
  },
  history: {
    type: Array,
    required: false,
    default: () => [],
  },
  isExpanded: {
    type: Boolean,
    required: false,
    default: false,
  },
  index: {
    type: Number,
    required: false,
    default: -1,
  },
  isChecked: {
    type: Boolean,
    required: false,
    default: false,
  },
  selectedAssessmentParent: {
    type: Array,
    required: false,
    default: () => [],
  },
  assessmentSelectedId: {
    type: Number,
    required: false,
    default: -1,
  },
});

const isOpen = ref(props.isExpanded);
const selectedAssessments: Ref = ref([]);
const selectedAssessmentParentRef: any = ref([]);
const isSelected: Ref = ref(false);
const emit = defineEmits([
  "onToggle",
  "selectAssessment",
  "selectedParentAssessment",
]);
watch(
  () => props.selectedAssessmentParent,
  (value) => {
    selectedAssessmentParentRef.value = value;
    if (value.length > 0) {
      selectedAssessments.value = [];
    }
  },
);
watch(
  () => selectedAssessments,
  (value) => {
    if (selectedAssessments.value.length > 0) {
      selectedAssessmentParentRef.value = [];
    }
  },
  { deep: true },
);
watch(
  () => props.isExpanded,
  () => {
    isOpen.value = props.isExpanded;
  },
);
watch(
  () => props.isChecked,
  () => {
    selectedAssessments.value = [];
    isSelected.value = false;
  },
);

const selectedParentAssessment = (data) => {
  emit("selectedParentAssessment", { data, index: props.index });
};
const selectedAssessment = (data) => {
  emit("selectAssessment", { data, index: props.index });
};
</script>

<style lang="scss" scoped>
.assessmentHistoryWrapper {
  border-bottom: 1px solid #eff0f1;
  background: #fcfcfd;
  transition: all 0.3s ease-in-out;
}

.close {
  height: 0;
  padding: 0;
  overflow: hidden;
  filter: blur(1px);
}

.assessmentHistory {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid #eff0f1;
  background: #ffffff;
}

.assessment:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.selected {
  border-bottom: 1px solid #eff0f1;
  background: #f2f8ff;
}
</style>
